import "./App.css";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";

import LandingPage from "./components/LandingPage/landingPage";
import HomePage from "./components/HomePage/HomePage";
import ClientsPage from "./components/ClientsPage/ClientsPage";
import CreateClient from "./components/CreateClient/CreateClient";
import SearchComponent from "./components/SearchComponent/SearchComponent";
import EditClient from "./components/EditClient/EditClient";
import FinancePage from "./components/FinancePage/FinancePage";
import Layout from "./components/Layout/Layout";

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<LandingPage />} />

        <Route
          path="/home"
          element={
            <Layout>
              <HomePage />
            </Layout>
          }
        />

        <Route
          path="/clients"
          element={
            <Layout>
              <ClientsPage />
            </Layout>
          }
        />

        <Route
          path="/finance"
          element={
            <Layout>
              <FinancePage />
            </Layout>
          }
        />

        <Route
          path="/create-client"
          element={
            <Layout>
              <CreateClient />
            </Layout>
          }
        />

        <Route
          path="/search"
          element={
            <Layout>
              <SearchComponent />
            </Layout>
          }
        />

        <Route
          path="/edit-client/:id"
          element={
            <Layout>
              <EditClient />
            </Layout>
          }
        />
      </Routes>
    </Router>
  );
}

export default App;
